module.exports = __webpack_public_path__ + "static/media/report.1002a11d.png";